const AppointmentRescheduleReason = {
  CUSTOMER_NOT_AVAILABLE: 'CUSTOMER_NOT_AVAILABLE',
  OTHER: 'OTHER',
  WAX_OCCLUSION: 'WAX_OCCLUSION',
  PROVIDER_ILLNESS: 'PROVIDER_ILLNESS',
  PROVIDER_UNAVAILABLE: 'PROVIDER_UNAVAILABLE',
  TECH_SETUP_NOT_REACHED: 'TECH_SETUP_NOT_REACHED',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET: 'TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT: 'TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT',
  TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED: 'TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED',
  // Network (NETWORK, NETWORK_HOME_DELIVERY) primary reasons
  SCHEDULE_CONFLICT: 'SCHEDULE_CONFLICT',
  WANTS_DIFFERENT_TIME: 'WANTS_DIFFERENT_TIME',
  NOT_READY: 'NOT_READY',
  TRAVEL_TRANSPORTATION_ISSUE: 'TRAVEL_TRANSPORTATION_ISSUE',
  HEALTH_ISSUE: 'HEALTH_ISSUE',
  CLINIC_PROVIDER_RESCHEDULE: 'CLINIC_PROVIDER_RESCHEDULE',
  // Germany (DE) primary reasons
  CUSTOMER: 'CUSTOMER',
  PARTNER: 'PARTNER',
  TECH: 'TECH',
  TECH_SETUP_INCOMPLETE: 'TECH_SETUP_INCOMPLETE',
} as const

type AppointmentRescheduleReason = (typeof AppointmentRescheduleReason)[keyof typeof AppointmentRescheduleReason]

type HumanAppointmentRescheduleReason = (typeof AppointmentRescheduleReason)[keyof typeof AppointmentRescheduleReason]

const HumanAppointmentRescheduleReason: Record<HumanAppointmentRescheduleReason, HumanAppointmentRescheduleReason> = {
  CUSTOMER_NOT_AVAILABLE: 'CUSTOMER_NOT_AVAILABLE',
  OTHER: 'OTHER',
  WAX_OCCLUSION: 'WAX_OCCLUSION',
  PROVIDER_ILLNESS: 'PROVIDER_ILLNESS',
  PROVIDER_UNAVAILABLE: 'PROVIDER_UNAVAILABLE',
  SCHEDULE_CONFLICT: 'SCHEDULE_CONFLICT',
  WANTS_DIFFERENT_TIME: 'WANTS_DIFFERENT_TIME',
  NOT_READY: 'NOT_READY',
  TRAVEL_TRANSPORTATION_ISSUE: 'TRAVEL_TRANSPORTATION_ISSUE',
  HEALTH_ISSUE: 'HEALTH_ISSUE',
  CLINIC_PROVIDER_RESCHEDULE: 'CLINIC_PROVIDER_RESCHEDULE',
  TECH_SETUP_NOT_REACHED: 'TECH_SETUP_NOT_REACHED',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET: 'TECH_SETUP_TECHNICAL_DIFFICULTIES_INTERNET',
  TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT: 'TECH_SETUP_TECHNICAL_DIFFICULTIES_EQUIPMENT',
  TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED: 'TECH_SETUP_TECHNICAL_TABLET_NOT_ARRIVED',
  CUSTOMER: 'CUSTOMER',
  PARTNER: 'PARTNER',
  TECH: 'TECH',
  TECH_SETUP_INCOMPLETE: 'TECH_SETUP_INCOMPLETE',
} as const

export { AppointmentRescheduleReason, HumanAppointmentRescheduleReason }
